import { GLOBAL_COLORS_HOLSTER } from '../config/globalSettings';

export const placardData = {
  // --- PLACARD MODELS ---
  placards: [
    { 
      id: "ghidorah_s", 
      name: "The Mini GHIDORAH-S", 
      price: 45.99, 
      qs_placard: true, 
      needs_pistol_mag: true, // <--- Triggers the new dropdown
      details: `
        <strong>Mini Ghidorah-S: Versatile KYDEX® Thermoplastics Magazine Carrier for Spiritus Systems JSTA</strong><br/><br/>
        The Mini Ghidorah-S is a game-changer for tactical loadouts, offering a versatile and efficient solution for carrying both pistol and rifle magazines in your Spiritus Systems JSTA pouch. This ambidextrous KYDEX® Thermoplastics magazine carrier provides a secure and customizable platform for your ammunition, ensuring you’re always prepared for any situation.<br/><br/>
        <strong>Key Features:</strong>
        <ul>
          <li><strong>Dual Magazine Capacity:</strong> Carries one pistol magazine and one rifle magazine, maximizing your firepower in a compact design.</li>
          <li><strong>Ambidextrous Design:</strong> Configure the carrier to your preference with rifle magazines forward or pistol magazines forward.</li>
          <li><strong>Universal Rifle Mag Compatibility:</strong> Fits all standard GI, Magpul, and Lancer-style rifle magazines.</li>
          <li><strong>Adjustable Retention:</strong> Fine-tune the retention for both pistol and rifle magazines to achieve your ideal draw tension.</li>
          <li><strong>Optimized for Spiritus Systems JSTA:</strong> Designed specifically for the Spiritus Systems JSTA pouch, ensuring a secure and seamless fit.</li>
          <li><strong>Durable KYDEX® Thermoplastics Construction:</strong> Built to withstand the rigors of tactical use and harsh environments.</li>
        </ul>
      `
    },
    { 
      id: "ghidorah_556", 
      name: "Ghidorah 556 Placard Insert", 
      price: 79.99, 
      qs_placard: true,
      needs_kaiju: true, 
      details: `
        <strong>Ghidorah 556 Placard Insert: Enhanced 5.56 Magazine Carry for Plate Carriers & Chest Rigs (NSN: 1005-66-167-0822)</strong><br/><br/>
        The Ghidorah 556 is a high-performance KYDEX® Thermoplastics placard insert designed to optimize your 5.56 magazine carry in plate carriers and chest rigs. This single-unit carrier offers superior retention, ease of use, and a comfortable fit, ensuring your magazines are always ready when you need them.<br/><br/>
        <strong>Key Features:</strong>
        <ul>
          <li><strong>Universal Compatibility:</strong> Fits most chest rigs and plate carrier placard kangaroo pouches, providing a versatile solution for 5.56 magazine carry.</li>
          <li><strong>Individual Adjustable Retention:</strong> Fine-tune the fit for each magazine, ensuring a secure hold and smooth draw every time.</li>
          <li><strong>Flared Magwells:</strong> Facilitates quick and effortless magazine insertion, even in high-stress situations.</li>
          <li><strong>Elevated Ride Height:</strong> The elongated KYDEX® Thermoplastics offset provides a 1″ higher ride height than standard pouches, improving accessibility and comfort.</li>
          <li><strong>Curved Design:</strong> Contoured to fit most plate carriers comfortably, minimizing bulk and maximizing comfort.</li>
          <li><strong>Durable KYDEX® Thermoplastics Construction:</strong> Crafted from 0.080″ black KYDEX® Thermoplastics for long-lasting performance and resilience.</li>
          <li><strong>NSN Marked:</strong> Designated with NSN 1005-66-167-0822 for official procurement and use.</li>
        </ul>
        <br/>
        <strong>Enhanced Compatibility with ANR/Cole-tac Kaiju Stiffy Kits:</strong><br/>
        The Ghidorah 556 includes six Velcro HOOK squares for easy attachment to your placard. This design ensures 100% compatibility with ANR/Cole-tac Kaiju Stiffy Kits, allowing for further customization and stability. (Kaiju Stiffy Kits can be found in the store or added on in the Ghidorah product builder.)
      `
    },
    { 
      id: "ghidorah_308", 
      name: "Ghidorah 308 Placard Insert", 
      price: 79.99, 
      qs_placard: true,
      needs_kaiju: true, 
      details: `
        The Ghidorah 308 is a high-performance KYDEX® Thermoplastics placard insert designed to optimize your .308 magazine carry in plate carriers and chest rigs. This single-unit carrier offers superior retention, ease of use, and a comfortable fit, ensuring your magazines are always ready when you need them.<br/><br/>
        <strong>Key Features:</strong>
        <ul>
          <li><strong>Universal Compatibility:</strong> Fits most chest rigs and plate carrier placard kangaroo pouches, providing a versatile solution for .308 magazine carry.</li>
          <li><strong>Individual Adjustable Retention:</strong> Fine-tune the fit for each magazine, ensuring a secure hold and smooth draw every time.</li>
          <li><strong>Flared Magwells:</strong> Facilitates quick and effortless magazine insertion, even in high-stress situations.</li>
          <li><strong>Elevated Ride Height:</strong> The elongated KYDEX® Thermoplastics offset provides a 1″ higher ride height than standard pouches, improving accessibility and comfort.</li>
          <li><strong>Curved Design:</strong> Contoured to fit most plate carriers comfortably, minimizing bulk and maximizing comfort.</li>
          <li><strong>Durable KYDEX® Thermoplastics Construction:</strong> Crafted from 0.080″ black KYDEX® Thermoplastics for long-lasting performance and resilience.</li>
          <li><strong>Compatibility:</strong> Fits SR25 and Magpul SR25 style magazines.</li>
        </ul>
        <br/>
        <strong>Enhanced Compatibility with ANR/Cole-tac Kaiju Stiffy Kits:</strong><br/>
        The Ghidorah 308 includes four Velcro HOOK squares for easy attachment to your placard. This design ensures 100% compatibility with ANR/Cole-tac Kaiju Stiffy Kits, allowing for further customization and stability. (Kaiju Stiffy Kits can be found in the store or added on in the Ghidorah product builder.)
      `
    },
    { 
      id: "ghidorah_s_556", 
      name: "Ghidorah-S 556 Placard Insert", 
      price: 74.99, 
      qs_placard: true,
      details: `
        <strong>Ghidorah-S 556 Placard Insert: Optimized Magazine Carry for Spiritus Systems Micro Fight MK4</strong><br/><br/>
        The Ghidorah-S 556 is a high-performance KYDEX® Thermoplastics placard insert designed to optimize your 5.56 magazine carry specifically in the Spiritus Systems Micro Fight MK4 kangaroo pouch. This single-unit carrier offers superior retention, ease of use, and a comfortable fit, ensuring your magazines are always ready when you need them.<br/><br/>
        <strong>Key Features:</strong>
        <ul>
          <li><strong>Precision Fit for Micro Fight MK4:</strong> Specifically designed to fit seamlessly within the Spiritus Systems Micro Fight MK4 kangaroo pouch.</li>
          <li><strong>Individual Adjustable Retention:</strong> Fine-tune the fit for each magazine, ensuring a secure hold and smooth draw every time.</li>
          <li><strong>Flared Magwells:</strong> Facilitates quick and effortless magazine insertion, even in high-stress situations.</li>
          <li><strong>Elevated Ride Height:</strong> The elongated KYDEX® Thermoplastics offset provides a 1″ higher ride height than standard pouches, improving accessibility and comfort.</li>
          <li><strong>Curved Design:</strong> Contoured to fit most plate carriers comfortably, minimizing bulk and maximizing comfort.</li>
          <li><strong>Durable KYDEX® Thermoplastics Construction:</strong> Crafted from 0.080″ black KYDEX® Thermoplastics for long-lasting performance and resilience.</li>
        </ul>
        <br/>
        <strong>Benefits:</strong>
        <ul>
          <li><strong>Secure and Reliable Retention:</strong> Keep your magazines securely in place within your Micro Fight MK4 pouch, preventing loss or damage.</li>
          <li><strong>Improved Accessibility:</strong> The elevated ride height and flared magwells ensure quick and easy magazine access.</li>
          <li><strong>Enhanced Comfort:</strong> The curved design conforms to your body, minimizing bulk and maximizing comfort.</li>
          <li><strong>Durable Construction:</strong> Built to withstand the rigors of tactical use and harsh environments.</li>
          <li><strong>Seamless Integration:</strong> Specifically designed for the Spiritus Systems Micro Fight MK4, ensuring a perfect fit.</li>
        </ul>
      `
    },
  ],

  // --- PISTOL MAG OPTIONS (For Mini Ghidorah S) ---
  pistol_mags: [
    { id: "cz_p10", name: "CZ P-10 S/C/F" },
    { id: "glock_9_40", name: "Glock 9/40" },
    { id: "sig_211_gto", name: "SIG 211-GTO" },
    { id: "sig_p320", name: "SIG P320" },
    { id: "sw_mp_20", name: "S&W M&P 2.0" }
  ],

  // --- KAIJU DECISION (Price Logic) ---
  kaiju_kits: [
    { id: "no", name: "No Thanks", price: 0 },
    { id: "yes", name: "Yes, Add Kit", price: 29.99 }
  ],

  // --- KAIJU CARRIER OPTIONS (Model Logic) ---
  kaiju_carriers: [
    { id: "kaiju_h", name: "Kaiju-H (fits Haley Strategic)" },
    { id: "kaiju_a", name: "Kaiju-A (JPC, Ferro, Velocity/Mayflower)" }
  ],

  // --- COLORS ---
  colors: GLOBAL_COLORS_HOLSTER,

  // --- EXTRAS ---
  breakthrough: [ 
    { id: "no", name: "No Thanks", price: 0 }, 
    { id: "solvent", name: "Breakthrough Military Grade Solvent", price: 8.95 },
    { id: "oil", name: "Breakthrough Battle Born High Purity Oil", price: 8.95 },
    { id: "lubricant", name: "Breakthrough Battle Born Pro Lubricant", price: 12.95 },
    { id: "bundle", name: "Breakthrough Clean Bundle", price: 16.00 }
  ],

  warranties: [ 
    { id: "30_day", name: "30 Day Mfg Warranty", price: 0 }, 
    { id: "lifetime", name: "Lifetime Warranty", price: 12.99 } 
  ]
};